const FooterData = [{
        id: 1,
        li1: "IIT-JEE",
        li1link: "/studymaterial/iit",
        li2: "NEET",
        li2link: "/studymaterial/neet",
        li3: "Study Material",
        li3link: "/studymaterial",
        li4: "Test Series",
        li4link: "/testseries",
    },
    {
        id: 2,
        li1: "My-Account",
        li1link: "/profile",
        li2: "Log-In",
        li2link: "/login",
        li3: "Sign-Up",
        li3link: "/login",
        li4: "Test Series",
        li4link: "/testseries",
    },
];
export default FooterData;